import Vue from "vue";
import Vuex from "vuex";
import Login from "./item/login";
import Live from "./item/live";
import Pay from "./item/pay";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    Login,
    Live,
    Pay
  },
});
